"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onSeeked;
function onSeeked(event) {
  var _this = this;
  if (this.rawPlayer.paused) {
    this.emit('timeupdate', {});
  } else {
    // Start timeUpdate here as there is not always a play event
    this._emitTimeUpdate();
  }
  this._hideSpinnerClearDelay();
  // Supress seeking whilst rewinding
  if (this._rewind.interval) {
    return;
  }
  if (this.logger.times.SeekTime > 0 && !this._isPlayableDynamic) {
    this.logger.logTime('SeekTime', performance.now() - this.logger.times.SeekTime);
    this.logger.times.SeekTime = 0;
  }

  // If currently playing on auto-quality, ensure that the target quality is consistent
  if (this._playerState.autoQuality && this._qualities.normalised.length) {
    // Delay for as long as possible to minimise the chance of low-quality kicking in,
    // but not so long that we're guaranteed to cross HLS segment boundaries
    this._resetAutoTargetQualityTimeout = setTimeout(function () {
      return _this.resetAutoTargetQuality();
    }, 3000);
  }
  this._playerState.playStartClockTime = 0;

  // Switching between preloaded sources triggers this event instead of onCanPlay, for some reason.
  // Need to set _transitionToNextClip to false to keep timeupdate events emitting properly.
  this._transitionToNextClip = false;
  this.emit('seeked', event);
}